import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  createField,
  createValidateObject,
  getForm,
  storeSetFieldsErrors,
  storeSetFieldValue,
  addToFieldsArr,
  dropToFieldsArr,
  clearFieldArr,
  createFieldsArr,
  storeRecoveryFieldValues
} from '../../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_FROM = 'SEND_FROM';
const REQUEST_RECOVERY_FORM = 'REQUEST_RECOVERY_FORM';
const RECOVERY_FORM_FIELDS = 'RECOVERY_FORM_FIELDS';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
const CHANGE_FIELD_ROOMNAME = 'CHANGE_FIELD_ROOMNAME';
const CHANGE_FIELD_USERIDS = 'CHANGE_FIELD_USERIDS';
const ADD_USER_MODEL = 'ADD_USER_MODEL';
const REMOVE_USER_MODEL = 'REMOVE_USER_MODEL';
const CLEAR_USER_MODEL = 'CLEAR_USER_MODEL';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        ...createField({
          field: 'roomName',
          title: 'Название диалога',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }),
        ...createFieldsArr({
          field: 'userIds',
          title: 'Участники',
          value: [],
          validate: [],
          errors: []
        })
      },
      usersModels: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_IN_PROGRESS):
        return setRequestStateInProgress(state);
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, SEND_FROM):
        return state;
      case createActionName(name, REQUEST_RECOVERY_FORM):
        return state;
      case createActionName(name, RECOVERY_FORM_FIELDS): {
        const room = action.payload;
        const members = _.keyBy(room.members, 'id');
        room.userIds = Object.keys(members);
        return storeRecoveryFieldValues(state, room).merge({
          usersModels: members
        });
      }
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state.merge({
          errors: {}
        });

      // FIELDS
      case createActionName(name, CHANGE_FIELD_ROOMNAME): {
        return storeSetFieldValue(state, 'roomName', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_USERIDS): {
        return storeSetFieldValue(state, 'userIds', action.payload);
      }
      case createActionName(name, ADD_USER_MODEL): {
        return addToFieldsArr(
          state,
          ['fields', 'userIds'],
          action.payload.id.toString()
        ).merge({
          usersModels: {
            ...{ [action.payload.id]: action.payload },
            ...state.usersModels
          }
        });
      }
      case createActionName(name, REMOVE_USER_MODEL): {
        const clone = Immutable.asMutable(state, { deep: true });
        delete clone.usersModels[state.fields.userIds.value[action.payload]];
        return dropToFieldsArr(
          state,
          ['fields', 'userIds'],
          action.payload
        ).merge({
          usersModels: clone.usersModels
        });
      }
      case createActionName(name, CLEAR_USER_MODEL): {
        return clearFieldArr(state, 'userIds').merge({
          usersModels: {}
        });
      }
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendFrom = (parentName, payload) => ({
  type: createActionName(parentName, SEND_FROM),
  payload
});

export const requestRecoveryForm = (reducerName, payload) => ({
  type: createActionName(reducerName, REQUEST_RECOVERY_FORM),
  payload
});

export const recoveryFormFields = (reducerName, payload) => ({
  type: createActionName(reducerName, RECOVERY_FORM_FIELDS),
  payload
});

export const setErrors = (parentName, payload) => ({
  type: createActionName(parentName, SET_ERRORS),
  payload
});
export const clearAllErrors = (parentName, payload) => ({
  type: createActionName(parentName, CLEAR_ALL_ERRORS),
  payload
});

export const changeFieldRoomName = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_ROOMNAME),
  payload
});
export const changeFieldUserIds = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_USERIDS),
  payload
});
export const addUserModel = (parentName, payload) => ({
  type: createActionName(parentName, ADD_USER_MODEL),
  payload
});
export const removeUserModel = (parentName, payload) => ({
  type: createActionName(parentName, REMOVE_USER_MODEL),
  payload
});
export const clearUserModel = (parentName, payload) => ({
  type: createActionName(parentName, CLEAR_ALL_ERRORS),
  payload
});

// SELECTORS
export const selectFormBody = (state, parentName) =>
  getForm(getState(state, parentName));
export const selectRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestState');
export const selectFieldRoomName = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.roomName');
export const selectFieldUserIds = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.userIds');
export const selectUserModelById = (state, parentName, itemId) =>
  getState(state, parentName).usersModels[itemId];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/forms/createGroupRoom/createGroupRoomForm.js